import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { setFullViewportWidthStyles, theme } from "shared/lib/styles";

type ContainerProps = {
  $isMagazineStyle: boolean;
};

export const Container = styled.div<ContainerProps>`
  ${setFullViewportWidthStyles()}
  display: flex;
  flex-flow: column nowrap;
  border-block-end: 1px solid #000000;

  & {
    padding-inline: 20px;

    ${theme.breakpoints.up("tablet")} {
      padding-inline: 24px;
    }

    ${theme.breakpoints.up("mediumDesktop")} {
      display: flex;
      justify-content: center;
    }
  }

  ${props =>
    props.$isMagazineStyle &&
    css`
      padding-inline: 16px 12px;

      ${theme.breakpoints.up("tablet")} {
        padding-inline: 32px;
      }

      ${HeaderContainer} {
        ${theme.breakpoints.up("largeDesktop")} {
          inline-size: 1360px;
        }
      }

      ${theme.breakpoints.only("mobile")} {
        border-block-end: none;
      }
    `}
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;

  inline-size: 100%;
  block-size: 45px;
  margin-inline: auto;
  padding-block: 12px;
  box-sizing: border-box;

  background-color: transparent;

  ${theme.breakpoints.up("tablet")} {
    block-size: 48px;
  }

  ${theme.breakpoints.up("desktop")} {
    block-size: 54px;
    max-inline-size: 1392px;
  }
`;

/* Common containers for features */
export const LeftFeatureContainer = styled.div`
  display: flex;
  align-items: center;

  column-gap: 14px;

  ${theme.breakpoints.up("tablet")} {
    column-gap: 16px;
  }

  ${theme.breakpoints.up("desktop")} {
    column-gap: 20px;
  }
`;

export const CenterFeatureContainer = styled.div`
  display: none;
  ${theme.breakpoints.up("desktop")} {
    position: relative;

    display: flex;
    flex: 1 1 auto;
    flex-direction: row;
    justify-content: center;

    min-inline-size: 0;
    padding-inline: 20px;
  }
`;

export const AbsoluteCenterFeatureContainer = styled.div`
  position: absolute;
  inset-block-start: 50%;
  inset-inline-start: 50%;

  transform: translate(-50%, -50%);
`;

export const RightFeatureContainer = styled.div<{ $shouldSwap?: boolean }>`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  margin-inline-start: auto;

  column-gap: ${({ $shouldSwap }) => ($shouldSwap ? "8px" : "16px")};
`;

/* Home mini specific wrapper */
export const HomeMiniHeaderCenterWrapper = styled.div`
  display: flex;
  justify-content: center;

  inline-size: 100%;
`;

/* Article specific wrapper */
type ArticleHamburgerMenuLogoWrapperProps = {
  $shouldSwap?: boolean;
};

export const ArticleHamburgerMenuLogoWrapper = styled.div<ArticleHamburgerMenuLogoWrapperProps>`
  display: flex;

  column-gap: 14px;

  > *:empty {
    display: none !important;
  }

  ${theme.breakpoints.up("tablet")} {
    display: ${({ $shouldSwap }) => ($shouldSwap ? "flex" : "none")};
  }
`;

export const ArticleSearchSectionWrapper = styled.div`
  display: flex;
  align-items: center;

  ${theme.breakpoints.up("desktop")} {
    column-gap: 32px;
  }
`;

export const ArticleSectionAllTabWrapper = styled.div`
  display: flex;

  column-gap: 12px;
`;

export const ArticleIconsWrapper = styled.div`
  display: flex;

  column-gap: 12px;
`;

/* Style specific wrapper */
export const StyleHeaderLogoContainer = styled.div`
  margin-inline: auto;
  padding-block: 48px 10px;

  ${theme.breakpoints.up("desktop")} {
    padding-block-start: 64px;
  }

  ${theme.breakpoints.only("mobile")} {
    display: none;
  }
`;

export const StyleLeftWrapper = styled.div`
  display: flex;

  column-gap: 12px;
`;

export const StyleLogoWrapper = styled.div`
  position: absolute;
  inset-block-start: 50%;
  inset-inline-start: 50%;

  display: flex;
  gap: 12px;

  transform: translate(-50%, -50%);
`;

/* Default wrapper */
export const DefaultLeftWrapper = styled.div`
  display: flex;
  gap: 16px;

  ${theme.breakpoints.up("desktop")} {
    gap: 32px;
  }
`;
